import { isObject } from './assertions';
import type { TAppError } from './error';

// Podemos usar este fichero para migrar las funciones de helpers.js que queramos sin cambiar ese fichero a typescript de un solo golpe
export function sleep(ms = 800) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function getNextQueryValue(value: string | string[] | undefined) {
  if (value === undefined) return null;

  if (Array.isArray(value)) {
    value = value.join(',');
  }
  value = decodeURIComponent(value);
  if (typeof value === 'string' && value.trim() === '') return null;
  return value;
}

function uuidv4() {
  return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) => (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16));
}

export function getUUID() {
  if (typeof window !== 'undefined' && window?.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  return uuidv4();
}

// from https://gist.github.com/t3dotgg/a486c4ae66d32bf17c09c73609dacc5b
// Types for the result object with discriminated union
type Success<T> = {
  data: T;
  error: null;
};

type Failure<E> = {
  data: null;
  error: E;
};

type Result<T, E = TAppError> = Success<T> | Failure<E>;

// Main wrapper function
export async function tryCatch<T, E = TAppError>(promise: Promise<T>): Promise<Result<T, E>> {
  try {
    const data = await promise;
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error as E };
  }
}

export function tryCatchSync<T, E = TAppError>(func: () => T): Result<T, E> {
  try {
    const data = func();
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error as E };
  }
}
